/** Easing helpers, exactly as specified in §7. */

export const clamp = (value: number, lo: number, hi: number): number => {
    return Math.min(Math.max(value, lo), hi)
}

export const easeOutCubic = (t: number): number => {
    return 1 - Math.pow(1 - t, 3)
}

export const easeInOut = (t: number): number => {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2
}

/** power2.out — the chrome fade. */
export const easeOutQuad = (t: number): number => {
    return 1 - (1 - t) * (1 - t)
}
